import React, { useCallback, useMemo } from 'react';
import {
  BetResponseCode,
  freeBetStore,
  notificationStore,
  useTranslation,
} from '@pascal/pascal-core';
import {
  applicationStore,
  gameConfigStore,
  roundInfoStore,
} from '@pascal/pascal-core/shared/core/store';
import { observer } from 'mobx-react-lite';
import { globalTranslationKeys } from '../../../../enums';
import { doBetStore, gameStore, marketsStore } from '../../../../store';
import { plus } from '../../../../helpers/arithmeticOperations';

const BetButtonForMarkets = observer(({ decidedCallBackCall }) => {
  const t = useTranslation();

  const { Bet, BetForNextRound, Cancel } = globalTranslationKeys;
  const {
    marketBetData: { isMarketNextRoundBet },
    currentClickedMarket,
    currentMarketAmount,
    isDisabledMarketBetButton,
    isLoadingBetButton,
    isLoadingReBetButton,
  } = marketsStore;
  const { activeFreeBet } = freeBetStore;
  const { isBetsClosed } = gameStore;
  const { totalBetsAmount, reBetData } = doBetStore;
  const { roundId } = roundInfoStore;
  const {
    limits: { maxBet },
  } = gameConfigStore;
  const { isDemo } = applicationStore;
  const { InValidMaxBet, InValidMarket } = BetResponseCode;
  const handleDoBet = () => {
    if (currentClickedMarket) {
      doBetStore.doBetSender(true);
    } else {
      notificationStore.setNotificationType({ responseCode: InValidMarket });
    }
  };

  const activeClassName = useMemo(() => {
    if (isBetsClosed && !isMarketNextRoundBet) {
      return BetForNextRound;
    }
    if (isBetsClosed && isMarketNextRoundBet) {
      return Cancel;
    }
    return Bet;
  }, [isMarketNextRoundBet, isBetsClosed]);

  const handleBetButtonClick = useCallback(() => {
    if (isBetsClosed && isMarketNextRoundBet) {
      marketsStore.setIsNexRoundBet(false);
    } else if (isBetsClosed && !isMarketNextRoundBet) {
      if (currentClickedMarket) {
        marketsStore.setIsNexRoundBet(true);
      } else {
        notificationStore.setNotificationType({ responseCode: InValidMarket });
      }
    } else if (!isBetsClosed) {
      handleDoBet();
    }
  }, [activeClassName, isMarketNextRoundBet, isBetsClosed, currentClickedMarket]);

  const isShowReBetButton =
    reBetData.length && reBetData[0].roundId !== roundId && !isBetsClosed && !isMarketNextRoundBet;

  return (
    <>
      <button
        type='button'
        className={`bet-section-button ${
          isDisabledMarketBetButton || isLoadingBetButton || isLoadingReBetButton ? 'passive' : ''
        } ${
          activeClassName === BetForNextRound ? Bet.toLowerCase() : activeClassName.toLowerCase()
        } `}
        title={t(activeClassName)}
        onClick={() => {
          if (
            isDemo &&
            plus(Number(currentMarketAmount), Number(totalBetsAmount)) > Number(maxBet)
          ) {
            notificationStore.setNotificationType({ responseCode: InValidMaxBet });
          } else {
            decidedCallBackCall(handleBetButtonClick);
          }
        }}
      >
        <span className='bet-section-button-inner'>
          <span
            className={`bet-section-btn-title ${
              activeClassName === BetForNextRound || isShowReBetButton
                ? 'bet-section-btn-min-title'
                : ''
            }`}
          >
            {activeFreeBet?.id && activeClassName === Bet
              ? `${t(globalTranslationKeys?.FreeBet)} ${activeFreeBet?.remainingCount}`
              : t(activeClassName)}
          </span>
          <span className='bet-section-btn-info'>
            {activeFreeBet?.id &&
              !activeFreeBet?.isMinOddNull &&
              activeClassName !== Cancel &&
              `${t(globalTranslationKeys?.MinOdd)} x${activeFreeBet?.minOdd} `}
          </span>
          {isLoadingBetButton && <span className='circle-loader' />}
        </span>
      </button>
      {isShowReBetButton ? (
        <button
          className={`re-bet-button ${
            isDisabledMarketBetButton || isLoadingBetButton || isLoadingReBetButton ? 'passive' : ''
          } `}
          onClick={() => doBetStore.handleReBetClickAction()}
        >
          <span className='bet-section-btn-title'>{t(globalTranslationKeys.ReBet)}</span>
          {isLoadingReBetButton && <span className='circle-loader' />}
        </button>
      ) : (
        <></>
      )}

      {/* <div className='bet-btn-right-inner small-btn'> */}
      {/*  <div */}
      {/*    className={`bet-btn-holder ${isDisabledMarketBetButton ? 'passive' : ''} ${ */}
      {/*      activeClassName === BetForNextRound ? Bet.toLowerCase() : activeClassName.toLowerCase() */}
      {/*    } ${isLoadingBetButton ? 'bet-loading' : ''}`} */}
      {/*    title={t(activeClassName)} */}
      {/*  > */}
      {/*    <div */}
      {/*      className='bet-btn-inner' */}
      {/*      onClick={() => { */}
      {/*        if ( */}
      {/*          isDemo && */}
      {/*          plus(Number(currentMarketAmount), Number(totalBetsAmount)) > Number(maxBet) */}
      {/*        ) { */}
      {/*          notificationStore.setNotificationType({responseCode: InValidMaxBet}); */}
      {/*        } else { */}
      {/*          decidedCallBackCall(handleBetButtonClick); */}
      {/*        } */}
      {/*      }} */}
      {/*    > */}
      {/*      <span className='square-btn-shape left'> </span> */}
      {/*      <span className='square-btn-shape right'> </span> */}
      {/*      <button className='oddball-btn'> */}
      {/*        <p className='oddball-btn-txt'> */}
      {/*          {activeFreeBet?.id && activeClassName === Bet */}
      {/*            ? `${t(globalTranslationKeys?.FreeBet)} ${activeFreeBet?.remainingCount}` */}
      {/*            : t(activeClassName)} */}
      {/*        </p> */}
      {/*        <p className='oddball-btn-txt-min-odd'> */}
      {/*          {activeFreeBet?.id && */}
      {/*            activeClassName !== Cancel && */}
      {/*            `${t(globalTranslationKeys?.MinOdd)} ${activeFreeBet?.minOdd} `} */}
      {/*        </p> */}
      {/*        {isLoadingBetButton && <span className='circle-loader'/>} */}
      {/*      </button> */}
      {/*    </div> */}
      {/*  </div> */}
      {/* </div> */}
    </>
  );
});

export default BetButtonForMarkets;
